import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";

import BorderTabContent from "./BorderTabContent";
import BorderNav from "./BorderNav";
import CommonCardHeader from "../../Utils/CommonComponents/CommonCardHeader";
import { BorderTabsTitle } from "../../Utils/Constants";
import { borderTabsSubTitle } from "../../Data/UiKitsData/TabsData";
import { useLocation } from "react-router-dom";
import CardHeaderSpan from "../../Utils/CommonComponents/CardHeaderSpan";

export default function ProfileTabs() {
    const location = useLocation();
    // const employeeId = location.state?.employeeId;
    const employeeId = location.state?.employeeId ?? 0; // Default to 0
    const positionId = location.state?.positionId ?? 0; // Default to 0
    const tdate = location.state?.tdate ?? ''; // Default to an empty string
    const [basicTab, setBasicTab] = useState<string>('1');

    return (
        <div className="page-body p-2">
            <Col xxl={12}>
                <Card>
                    <CardHeaderSpan headingClassName='py-2 px-2' back={true} heading={'User Profile'} span={'Profile'} />

                    {/* <CommonCardHeader headClass="card-no-border pb-0" title={BorderTabsTitle} subTitle={borderTabsSubTitle} /> */}
                    <div className="">
                        <BorderNav basicTab={basicTab} setBasicTab={setBasicTab} employeeIdProp={employeeId}/>
                        <BorderTabContent tabId={basicTab} employeeIdProp={employeeId} tdate={tdate} positionId={positionId}/>
                    </div>
                </Card>
            </Col>
        </div>
    )
}
